export interface Notification {
  type: string
  message: string
}

export function useNotification() {
  const notification = useState<Notification | null>('notification', () => null)
  const timeoutId = useState<NodeJS.Timeout | null>('notificationTimeoutId', () => null)

  const show = (not: Notification) => {
    notification.value = not

    if (timeoutId.value !== null) {
      clearTimeout(timeoutId.value)
    }

    timeoutId.value = setTimeout(() => {
      close()
    }, 5000)
  }

  const close = () => {
    notification.value = null

    if (timeoutId.value !== null) {
      clearTimeout(timeoutId.value)
      timeoutId.value = null
    }
  }

  const onKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      close()
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', onKeydown)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', onKeydown)
  })

  return {
    notification,
    show,
    close,
  }
}
